export default "__VITE_PUBLIC_ASSET__ea0127ee__"